import { render } from "./ModalDownloadDocsBurofax.vue?vue&type=template&id=790a0a78&scoped=true"
import script from "./ModalDownloadDocsBurofax.vue?vue&type=script&lang=js"
export * from "./ModalDownloadDocsBurofax.vue?vue&type=script&lang=js"

import "./ModalDownloadDocsBurofax.vue?vue&type=style&index=0&id=790a0a78&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790a0a78"]])

export default __exports__